import axios from "axios";
const getDefaultState = () => {
  return {
    jsonApiHeader: {
      "Content-Type": "application/json; charset=UTF-8",
      Authorization:
        "key=AAAAXJUoq0o:APA91bFrPbkXyDt-cpTl4PoMYHi_jyvnkswWbcd4zM5uuCrTMrpLMBuVUNrxgIH3QIRAdjDBPGJucHqOaUvuh0eaP0Ke7u5H3jeOWtl8h4ztVQOWLLPuOcbM5qws7Bz2MKmlFXoa93Iz",
    },
    listeUsers: [],

    alertMsg: "",
    fcmUrl: "https://fcm.googleapis.com/fcm/send",
    fcmJson: {
      content_available: true,
      notification: {
        title: "",
        body: "",
        icon: "./img/icons/icon-192x192.png",
        click_action: "https://tanoramalagasy.web.app/",
      },
    },
  };
};
const state = getDefaultState();

const mutations = {
  RESET_STATE(state) {
    Object.assign(state, getDefaultState());
  },
  SET_alertMsg(state, payload) {
    state.NotificationToken = payload;
  },
  SET_listeUsers(state, payload) {
    state.listeUsers = payload;
  },
};

const actions = {
  resetState({ commit }) {
    commit("RESET_STATE");
  },

  setMessaging({ commit }) {
    console.log("tonga eto : setMessaging");
    let self = this;
    // messaging
    var user = self._vm.$firebase.auth().currentUser;
    const messaging = self._vm.$firebase.messaging();
    messaging.usePublicVapidKey(
      "BCS_RnyADNq9WijpAAVS9YNNaJfz2nG5m5C_EJe6AVGkCO2jOKawlm4JDayw4YLZ3n7Is5ZU5oadT7D165kQpkI"
    ); // 1. Generate a new key pair
    // Request Permission of Notifications
    messaging
      .requestPermission()
      .then(() => {
        let txt = "Les notifications sont activées";
        console.log(txt);
        let granted = {};
        granted.showSnackbar = true;
        granted.snackbarContent = txt;
        commit("Snackbar/SET_SNACKBAR", granted, { root: true });

        // Get Token
        messaging.getToken().then((token) => {
          console.log(token);
          commit("Auth/SET_NotificationToken", token, { root: true });
          var userRef = self._vm.$firebase
            .firestore()
            .collection("users")
            .doc(user.uid);
          userRef.set({ notificationToken: token }, { merge: true });
        });
      })
      .catch((err) => {
        console.log("Notification non autorisée", err);
        let snackerr = {};
        snackerr.showSnackbar = true;
        snackerr.snackbarContent = err;
        commit("Snackbar/SET_SNACKBAR", snackerr, { root: true });
      });

    //end messaging
  },

  async GetAllUsers({ commit }) {
    // start requête
    commit("SET_listeUsers", []);
    commit("RESET_STATE");
    commit("Loading/START_BUSY_STATE", "Notifications.store.js GetAllUsers", {
      root: true,
    });

    let elems = [];
    this._vm.$firebase
      .firestore()
      .collection("users")
      .get()
      .then(
        (snapshot) => {
          if (snapshot.metadata.hasPendingWrites) {
            console.log("il en reste");
            commit(
              "Pending/START_PENDING_STATE",
              "Notifications.store.js GetAllUsers",
              { root: true }
            );
          } else {
            console.log(
              "tout est synchronisé Dans Notifications.store.js GetAllUsers"
            );
            commit(
              "Pending/END_PENDING_STATE",
              "Notifications.store.js GetAllUsers",
              { root: true }
            );
          }
          snapshot.forEach(function (doc) {
            elems.push({
              ...doc.data(),
              id: doc.id,
            });
          });

          if (!elems) {
            console.log("No Data Available");
            return false;
          } else {
            commit("SET_listeUsers", elems);
            commit(
              "Loading/END_BUSY_STATE",
              "Notifications.store.js GetAllUsers",
              {
                root: true,
              }
            );
          }
        },
        (error) => {
          console.log(error);
          let snackbar = {};
          snackbar.showSnackbar = true;
          snackbar.snackbarContent = error.message;
          commit("Snackbar/SET_SNACKBAR", snackbar, { root: true });
          commit("Loading/END_BUSY_STATE", "Themes.store.js", {
            root: true,
          });
        }
      );
  },
  // sendNotification
  sendNotification({ dispatch, commit }) {
    commit("SET_alertMsg", "Please wait...");
    console.log("submitAction");
    dispatch("postToFirebase").then((result) => {
      console.log(result);
      commit("SET_alertMsg", "");
    });
  },
  // sendNotification
  async postToFirebase({ commit }) {
    console.log("postToFirebase");
    const dataParam = this.state.Notifications.fcmJson;
    let tokens = [];
    this.state.Notifications.listeUsers.forEach(function (token, index) {
      if (token.notificationToken) {
        tokens[index] = token.notificationToken;
      }
    });

    console.log(tokens);
    dataParam.registration_ids = tokens;
    try {
      const response = await axios({
        method: "post",
        url: this.state.Notifications.fcmUrl,
        headers: this.state.Notifications.jsonApiHeader,
        data: dataParam,
      });
      commit("RESET_STATE");
      return response;
    } catch (error) {
      console.error(error);
      let snackerr = {};
      snackerr.showSnackbar = true;
      snackerr.snackbarContent = error;
      commit("Snackbar/SET_SNACKBAR", snackerr, { root: true });
    }
  },
};

const getters = {};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
